export default __webpack_public_path__ + "static/media/double-double-border-left.03dfcd6a.svg";